import { sumBy } from 'lodash'
import api from '@/common/api/cobrandApiClient'
import { QUEST_CODE_SELECT } from '@/constants'

// export const FETCH_RANDOM_TASKS_START = 'FETCH_RANDOM_TASKS_START'
export const FETCH_RANDOM_TASKS_SUCCESS = 'FETCH_RANDOM_TASKS_SUCCESS'
export const FETCH_RANDOM_TASKS_ERROR = 'FETCH_RANDOM_TASKS_ERROR'
export const SET_TASKS = 'SET_TASKS'

export const PARTICIPATE_START = 'PARTICIPATE_START'
export const PARTICIPATE_SUCCESS = 'PARTICIPATE_SUCCESS'
export const PARTICIPATE_ERROR = 'PARTICIPATE_ERROR'
export const PARTICIPATE_ERROR_CLEAR = 'PARTICIPATE_ERROR_CLEAR'

export const PLAY_SUCCESS = 'PLAY_SUCCESS'
export const PLAY_ERROR = 'PLAY_ERROR'

export const RESET_CARD_IMAGE = 'RESET_CARD_IMAGE'

export const SOCIAL_SUCCESS = 'SOCIAL_SUCCESS'
export const SOCIAL_ERROR = 'SOCIAL_ERROR'

export const FETCH_RANDOM_REWARDS_START = 'FETCH_RANDOM_REWARDS_START'
export const FETCH_RANDOM_REWARDS_SUCCESS = 'FETCH_RANDOM_REWARDS_SUCCESS'
export const FETCH_RANDOM_REWARDS_ERROR = 'FETCH_RANDOM_REWARDS_ERROR'

export const QUIZ_STARTED = 'QUIZ_STARTED'
export const FETCH_QUIZ_SUCCESS = 'FETCH_QUIZ_SUCCESS'
export const FETCH_QUIZ_ERROR = 'FETCH_QUIZ_ERROR'
export const POST_QUIZ_SUCCESS = 'POST_QUIZ_SUCCESS'
export const POST_QUIZ_ERROR = 'POST_QUIZ_ERROR'

export const ERROR_UNKNOWN = 'ERROR_UNKNOWN'

export const defaultState = {
  tasksFilter: [],
  tasks: [],
  selectedTasksFilter: null,
  startTask: true,
  error: null,
  errorDetails: null,
  isParticipant: false,
  participateProcess: false,
  spinBalance: 0,
  cardType: '',
  tag: '',
  cardCode: null,
  cardCodeHidden: null,
  cardImage: null,
  cardText: null,
  rewards: [],
  socialTasksExist: false,
  socialSuccess: false,
  quizSetup: [],
  quizStarted: false,
  quizTask: null,
  quizSpins: 0,
  quizSuccess: false,
  finishedTotal: 0,
  spinsTotal: 0,
  participateCardCode: null
}
export const mutations = {
  [FETCH_RANDOM_TASKS_SUCCESS] (state, {
    cardCode,
    taskFilters,
    tasks,
    spinBalance,
    cardType,
    tag,
    totalSpinsAccrued
  }) {
    const originTasks = [...tasks]
    const compareFields = ['title', 'filterValue', 'oneTime', 'questCode', 'spins', 'text', 'questDescription']
    const groups = {}
    const updatedTasks = []
    let finishedTotalCounter = 0
    state.tasksFilter = [...taskFilters]
    originTasks.forEach((item, index) => {
      if (item.oneTime && item.finishedCount) {
        finishedTotalCounter += item.finishedCount
      }
      groups[item.title + item.text + item.questCode] = [{ ...item }]
      originTasks.forEach((compareItem, compareIndex) => {
        for (let i of compareFields) {
          if (item[i] !== compareItem[i]) {
            return true
          }
        }
        if (index !== compareIndex) {
          groups[compareItem.title + compareItem.text + compareItem.questCode].push({ ...compareItem })
        }
      })
    })
    Object.values(groups).forEach((item) => {
      const task = { ...item[0] }
      const finishedCount = sumBy(item, 'finishedCount')
      task.completedCount = finishedCount
      task.mergedCount = item.length
      task.completed = task.completedCount === task.mergedCount
      updatedTasks.push(task)
    })
    state.finishedTotal = finishedTotalCounter
    state.spinsTotal = totalSpinsAccrued
    state.tasks = [ ...updatedTasks ]
    state.startTask = taskFilters.some(item => item.value === 'START')
    state.cardCode = cardCode
    state.cardType = cardType
    state.tag = tag
    if (cardCode) {
      state.isParticipant = true
      state.cardCodeHidden = cardCode.replace(/.*(.{4})$/, 'XXXX - XXXX - %(mark_start)s$1%(mark_end)s')
      state.spinBalance = spinBalance
      state.socialTasksExist = !!tasks.find(item => (item.questCode === QUEST_CODE_SELECT.SOCIAL_SHARE))
      state.selectedTasksFilter = state.tasksFilter[0]
      state.quizTask = tasks.find(item => (item.questCode === QUEST_CODE_SELECT.QUIZ_FINISH))
      if (state.quizTask) {
        state.quizSpins = state.quizTask.spins
      }
    }
  },
  [SET_TASKS] (state, value) {
    state.selectedTasksFilter = state.tasksFilter.find(item => item.value === value)
  },
  [FETCH_RANDOM_TASKS_ERROR] (state, error) {
    state.error = FETCH_RANDOM_TASKS_ERROR
    if (error.code >= 500) {
      state.error = ERROR_UNKNOWN
    }
  },
  [PARTICIPATE_START] (state) {
    state.participateProcess = true
  },
  [PARTICIPATE_SUCCESS] (state, { data }) {
    state.participateProcess = false
    state.spinBalance = data.spinBalance
    state.isParticipant = true
    state.cardCode = data.cardCode
    state.cardCodeHidden = data.cardCode.replace(/.*(.{4})$/, 'XXXX - XXXX - $1')
    state.cardType = data.cardType
    state.tag = data.tag
    state.participateCardCode = null
  },
  // eslint-disable-next-line camelcase
  [PARTICIPATE_ERROR] (state, { error, card_code }) {
    state.participateProcess = false
    state.error = PARTICIPATE_ERROR
    // eslint-disable-next-line camelcase
    state.participateCardCode = card_code
    try {
      state.errorDetails = error.errors[0].detail
    } catch (err) {
      // eslint-disable-next-line
      console.info('err:', err)
    }
    if (error.code >= 500) {
      state.error = ERROR_UNKNOWN
    }
  },
  [PARTICIPATE_ERROR_CLEAR] (state) {
    if (state.error === PARTICIPATE_ERROR) {
      state.error = null
      state.errorDetails = null
    }
  },
  [PLAY_SUCCESS] (state, { prizeData, spinsRemained }) {
    state.cardImage = prizeData.image
    state.cardText = prizeData.text
    state.spinBalance = spinsRemained
  },
  [RESET_CARD_IMAGE] (state) {
    state.cardImage = null
    state.cardText = ''
  },
  [SOCIAL_SUCCESS] (state, data) {
    state.socialSuccess = true
  },
  [SOCIAL_ERROR] (state, error) {
    state.socialSuccess = false
    state.error = SOCIAL_ERROR
    if (error.code >= 500) {
      state.error = ERROR_UNKNOWN
    }
  },
  [FETCH_RANDOM_REWARDS_SUCCESS] (state, { data }) {
    state.rewards = data
  },
  [QUIZ_STARTED] (state) {
    state.quizStarted = true
  },
  [FETCH_QUIZ_SUCCESS] (state, data) {
    state.quizSetup = data.quizSetup
  },
  [FETCH_QUIZ_ERROR] (state, error) {
    state.error = FETCH_QUIZ_ERROR
    if (error.code >= 500) {
      state.error = ERROR_UNKNOWN
    }
  },
  [POST_QUIZ_SUCCESS] (state) {
    state.quizSuccess = true
  },
  [POST_QUIZ_ERROR] (state, error) {
    state.error = POST_QUIZ_ERROR
    if (error.code >= 500) {
      state.error = ERROR_UNKNOWN
    }
  }
}
export const actions = {
  async fetchTasks ({ commit, rootState }) {
    // commit(FETCH_RANDOM_TASKS_START)
    try {
      const accountId = rootState.auth.user.id
      const { data } = await api.fetchRandomRewardsTasks(accountId)
      commit(FETCH_RANDOM_TASKS_SUCCESS, data)
    } catch (error) {
      // eslint-disable-next-line
      console.info('error:', { error })
      commit(FETCH_RANDOM_TASKS_ERROR, error)
    }
  },
  setTaskFilter ({ commit }, value) {
    commit(SET_TASKS, value)
  },
  // eslint-disable-next-line camelcase
  async participate ({ commit, dispatch, rootState }, card_code) {
    commit(PARTICIPATE_START)
    try {
      const accountId = rootState.auth.user.id
      const { data } = await api.participateRandomRewards(accountId, card_code)
      await dispatch('fetchTasks')
      commit(PARTICIPATE_SUCCESS, { data, card_code })
    } catch (error) {
      // eslint-disable-next-line
      console.info('error:', { error })
      commit(PARTICIPATE_ERROR, { error, card_code })
    }
  },
  async play ({ commit, rootState }) {
    try {
      const accountId = rootState.auth.user.id
      const { data } = await api.playRandomRewards(accountId)
      commit(PLAY_SUCCESS, data)
    } catch (error) {
      // eslint-disable-next-line
      console.info('error:', { error })
      commit(PLAY_ERROR, error)
    }
  },
  async social ({ commit, dispatch, rootState }) {
    try {
      const accountId = rootState.auth.user.id
      const { data } = await api.socialRandomRewards(accountId)
      await dispatch('fetchTasks')
      commit(SOCIAL_SUCCESS, data)
    } catch (error) {
      // eslint-disable-next-line
      console.info('error:', { error })
      commit(SOCIAL_ERROR, error)
    }
  },
  async fetchRewards ({ commit, rootState }) {
    // commit(FETCH_RANDOM_REWARDS_START)
    try {
      const { data } = await api.fetchRandomRewards()
      commit(FETCH_RANDOM_REWARDS_SUCCESS, data)
    } catch (error) {
      // eslint-disable-next-line
      console.info('error:', { error })
      commit(FETCH_RANDOM_REWARDS_ERROR, error)
    }
  },
  async fetchQuiz ({ commit, rootState }) {
    // commit(FETCH_RANDOM_REWARDS_START)
    try {
      const accountId = rootState.auth.user.id
      const { data } = await api.fetchQuizRandomRewards(accountId)
      commit(FETCH_QUIZ_SUCCESS, data)
    } catch (error) {
      // eslint-disable-next-line
      console.info('error:', { error })
      commit(FETCH_QUIZ_ERROR, error)
    }
  },
  async postQuiz ({ commit, dispatch, rootState }) {
    try {
      const accountId = rootState.auth.user.id
      const { data } = await api.postQuizRandomRewards(accountId)
      await dispatch('fetchTasks')
      commit(POST_QUIZ_SUCCESS, data)
    } catch (error) {
      // eslint-disable-next-line
      console.info('error:', { error })
      commit(POST_QUIZ_ERROR, error)
    }
  },
  startQuiz ({ commit }) {
    commit(QUIZ_STARTED)
  },
  clearBindingCardError ({ commit }) {
    commit(PARTICIPATE_ERROR_CLEAR)
  },
  resetCardImage ({ commit }) {
    commit(RESET_CARD_IMAGE)
  }
}

export default {
  namespaced: true,
  state: () => defaultState,
  mutations,
  actions
}
